// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__NyokV","colCheckbox":"styles_colCheckbox__U_hOO"};